import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import DropMenuLogin from "../drop-down-menus/DropMenuLogin";
import ShoppingCart from "../../pages/shop/shoppingCart";
import { useAuth } from "../../context/AuthContext";
import React from "react";
import "./topbarv2.scss";

const DEFAULT_COLOURS = {
  shopBasket: "top-bar-right-basketv2",
  dropMenuOuter: "SignInContainerScrolled",
  dropMenuText: "top-bar-right-login-scrl",
  dropMenuIcon: "top-bar-right-icon-scrl",
  iconBorder: "top-bar-right-login-img",
};

const HOME_COLOURS = {
  ...DEFAULT_COLOURS,
  shopBasket: "top-bar-right-basketv2-location",
  iconBorder: "top-bar-right-login-img-home",
};

export default function TopBarV2() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(window.scrollY > 50);
  const { isLoggedIn, currentUserRole} = useAuth();
  
  const isAdmin = isLoggedIn && currentUserRole === 'admin';
  

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const topBarColours =
    location.pathname === "/" && !isScrolled ? HOME_COLOURS : DEFAULT_COLOURS;

  return (
    <>
      <div className="topBarV2">
        <div className="topBarContainer">
          <section className="topBarLeft">
            <Link to="/" className="topBarLeftLogoLink">
              <p>
                am <span className="topBarSlash">/</span> human
              </p>
            </Link>
          </section>
          <section className="topBarRight">
            <ul className="topBarRightList">
              <li className="topBarRightListItem topBarNavItem">
                <Link to="/Shop" className="topBarRightListItemLink">
                  Shop
                </Link>
              </li>
              <li className="topBarRightListItem topBarNavItem">
                <Link to="/Recipes" className="topBarRightListItemLink">
                  Recipes
                </Link>
              </li>
              <li className="topBarRightListItem topBarNavItem">
                <Link to="/About" className="topBarRightListItemLink">
                  About
                </Link>
              </li>
              <li className="topBarRightListItem topBarNavItem">
                <Link to="/Orders" className="topBarRightListItemLink">
                  Orders
                </Link>
              </li>
              <li className="topBarRightListItem topBarShopBasket">
                <ShoppingCart ShopingStyle={topBarColours.shopBasket} />
              </li>
              <li>
                <DropMenuLogin
                  dropMenuOuter={topBarColours.dropMenuOuter}
                  dropMenuText={topBarColours.dropMenuText}
                  dropMenuIcon={topBarColours.dropMenuIcon}
                  iconBorder={topBarColours.iconBorder}
                />
              </li>
            </ul>
          </section>
        </div>
      </div>
    </>
  );
}
